import React from 'react';
import { TouchableOpacity, Platform } from 'react-native';
import { Surface } from 'react-native-paper';
import { Trans } from '@lingui/macro';
import { useNavigation } from '@react-navigation/native';
import styled, { css } from 'styled-components/native';

import Image from '@src/components/Image';
import ImageBackground from '@src/components/ImageBackground';
import { H1, H2, Subtitle2 } from '@src/components/Typography';
import {
  activeOpacity,
  primeBookCardHeight,
  primeBookCardWidth,
} from '@src/configuration/constants';
import { padding, windowWidth } from '@src/configuration/constants';
import { PrimeBook } from '@src/types';

const height = 300;
type Props = {
  item: PrimeBook;
  isImmigration?: boolean;
  onLongPress?: () => void;
};

const Container = styled.View`
  width: ${primeBookCardWidth}px;
  height: ${primeBookCardHeight}px;
  justify-content: space-between;
`;

const Cover = styled(ImageBackground)`
  border-radius: ${({ theme }) => theme.roundness}px;
  background-color: ${({ theme }) => theme.colors.placeholder};
  overflow: hidden;
  resize-mode: contain;
  ${Platform.select({
    ios: css`
      flex: 1;
    `,
    web: css`
      display: inline;
    `,
  })};
  margin: 0 auto;
  height: 100%;
  width: 100%;
`;

const CoverContainer = styled(Surface)`
  border-radius: ${({ theme }) => theme.roundness}px;
  background-color: ${({ theme }) => theme.colors.placeholder};
  width: ${primeBookCardWidth}px;
  height: ${primeBookCardHeight - 64}px;
`;

const Component: React.FC<Props> = (props) => {
  const {
    item: { title, cover, type, id },
    isImmigration,
    onLongPress,
  } = props;

  const navigation = useNavigation();
  const handlePress = React.useCallback(() => {
    console.log('fg', id);
    isImmigration
      ? navigation.navigate('ImmigrationBook', { id })
      : navigation.navigate('PrimeBook', { id });
  }, [id, navigation]);

  return (
    <TouchableOpacity
      activeOpacity={activeOpacity}
      onPress={handlePress}
      onLongPress={onLongPress}
    >
      <Container>
        <CoverContainer>
          <Cover source={cover.source} />
        </CoverContainer>
        <H2 numberOfLines={2}>{title}</H2>

        <Subtitle2>
          {type === 1 ? (
            <Trans>Text</Trans>
          ) : type === 2 ? (
            <Trans>Audio</Trans>
          ) : (
            <Trans>Text & Audio</Trans>
          )}
        </Subtitle2>
      </Container>
    </TouchableOpacity>
  );
};

Component.displayName = 'PrimeBookCard';

export default React.memo(Component);
